<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h4>Foto</h4>
        <span>Adicione uma foto sua.</span>
        </div>
      <div class="col-md-8">
        <img class="profile-photo" :src="picture" />
        <span v-if="isUploadingPicture">Aguarde...</span>
        <a v-else href="#" v-on:click.stop.prevent="selectPhoto()" class="change-photo">Mudar foto</a>
        <input ref="uploadBtn" class="input-photo" type="file" @change="uploadPhoto" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4>Seus dados</h4>
        <span>Complete com seus dados pessoais.</span>
      </div>
      <div class="col-md-8">
        <div class="profile-data">

          <div class="row">
            <div class="form-group col-sm">
              <label>Nome completo</label>
              <input type="text" class="form-control" name="fullname" placeholder="Informe seu nome completo" v-model="fullname"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>E-mail</label>
              <input type="email" class="form-control" name="email" placeholder="Informe seu email" v-model="email"/>
            </div>
          </div>

          <div class="row" v-if="user && user.profile != 'ong'">
            <div class="form-group col-sm">
              <label>CPF</label>
              <input v-mask="'###.###.###-##'" type="text" class="form-control" name="cpf" placeholder="Informe seu CPF" v-model="cpf"/>
            </div>
          </div>

          <div class="row" v-if="user && user.profile == 'ong'">
            <div class="form-group col-sm">
              <label>CNPJ</label>
              <input v-mask="'##.###.###/####-##'" type="text" class="form-control" name="cnpj" placeholder="Informe seu CNPJ" v-model="cnpj"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Telefone fixo</label>
              <input v-mask="'(##) ####-####'" type="phone" class="form-control" name="phone" placeholder="(11) 9999-9999" v-model="phone"/>
            </div>
            <div class="form-group col-sm">
              <label>Telefone móvel</label>
              <input v-mask="'(##) #####-####'" type="phone" class="form-control" name="celphone" placeholder="(11) 99999-9999" v-model="celphone"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Endereço</label>
              <input type="text" class="form-control" name="address" placeholder="" v-model="address"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Bairro</label>
              <input type="text" class="form-control" name="hood" placeholder="" v-model="hood"/>
            </div>
            <div class="form-group col-sm">
              <label>Cidade</label>
              <input type="text" class="form-control" name="city" placeholder="" v-model="city"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Estado</label>
              <input type="text" class="form-control" name="province" placeholder="" v-model="province"/>
            </div>
            <div class="form-group col-sm">
              <label>CEP</label>
              <input v-mask="'##.###-###'" type="text" class="form-control" name="cep" placeholder="" v-model="cep"/>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4>Preferências</h4>
        <span>Defina as suas preferências na plataforma.</span>
      </div>
      <div class="col-md-8">
        <div class="profile-data">
          <b-form-group label="Categorias de ONGS preferidas">
            <b-form-checkbox-group id="checkbox-group-2" v-model="selectedCategories" name="flavour-2" stacked>
              <b-form-checkbox size="lg" value="animais">Animais</b-form-checkbox>
              <b-form-checkbox size="lg" value="criancas">Crianças</b-form-checkbox>
              <b-form-checkbox size="lg" value="cultura">Cultura</b-form-checkbox>
              <b-form-checkbox size="lg" value="educacao">Educação</b-form-checkbox>
              <b-form-checkbox size="lg" value="esportes">Esportes</b-form-checkbox>
              <b-form-checkbox size="lg" value="emergencia">Emergências</b-form-checkbox>
              <b-form-checkbox size="lg" value="idosos">Idosos</b-form-checkbox>
              <b-form-checkbox size="lg" value="religiao">Religião</b-form-checkbox>
              <b-form-checkbox size="lg" value="mulher">Mulheres</b-form-checkbox>
              <b-form-checkbox size="lg" value="natureza">Natureza</b-form-checkbox>
              <b-form-checkbox size="lg" value="deficientes">Pessoas com Deficiência</b-form-checkbox>
              <b-form-checkbox size="lg" value="saude">Saúde</b-form-checkbox>
              <b-form-checkbox size="lg" value="social">Social</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <b-form-group label="Categorias de lojas preferidas">
            <b-form-checkbox-group id="checkbox-group-2" v-model="selectedStoreCategories" name="flavour-2" stacked>
              <b-form-checkbox v-for="category in storeCategories" :key="category.categoryId" size="lg" :value="category.categoryId">{{category.categoryName}}</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4>Habilidade</h4>
        <span>Informe uma habilidade que você possui e que possa ajudar nossos projeto sociais.</span>
      </div>

      <div class="col-md-8">
        <b-form-group>
          <b-form-radio-group id="checkbox-group-7" v-model="selectedHability" name="flavour-3" stacked>
            <b-form-radio v-for="(c, k) in arrHabilitiesWithMessages" size="lg" :value="c.hability" :key="k">{{ c.message }}</b-form-radio>
          </b-form-radio-group>
      </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4>Senha</h4>
        <span>Atualize sua senha e mantenha sua conta segura.</span>
      </div>
      <div class="col-md-8">
        <div class="profile-data">
          <div class="row">
            <div class="form-group col-sm">
              <label>Senha atual</label>
              <input type="password" class="form-control" name="password" placeholder="" v-model="password"/>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm">
              <label>Nova senha</label>
              <input type="password" class="form-control" name="newPassword" placeholder="" v-model="newPassword"/>
            </div>
            <div class="form-group col-sm">
              <label>Confirmar nova senha</label>
              <input type="password" class="form-control" name="newPasswordConfirm" placeholder="" v-model="newPasswordConfirm"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{msg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
          {{successMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <button class="btn submit" v-on:click.stop.prevent="save()">Salvar Alterações</button>
      </div>
    </div>

    <b-modal size="lg" v-model="showHabilityModal" title="Selecione sua Habilidade">
      <p>
        A Click2giv é uma plataforma que tem por objetivo aproximar pessoas, conectar aqueles que desejam contribuir, com aqueles que necessitam de contribuição. <br><br>
        Agora você pode contribuir com uma Organização Social através de algum conhecimento que você tenha, alguma habilidade, especialização, e assim ajudar a
        transformar a vida de milhares de pessoas. <br><br>
        Escolha na lista abaixo as habilidades que você possui e que gostaria de disponibilizar para uma Organização Social. Identificaremos uma ONG que necessita
        deste apoio e colocaremos vocês em contato.
      </p>

      <b-form-group>
        <b-form-radio-group id="checkbox-group-2" v-model="selectedHability" name="flavour-2" stacked>
          <b-form-radio v-for="(c, k) in arrHabilitiesWithMessages" size="lg" :value="c.hability" :key="k">{{ c.message }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import {mask} from 'vue-the-mask'
import constants from '../../services/constants';

export default {
  name: 'FormProfile',
  props: ['user'],
  directives: {mask},
  data () {
    return {
      msg: "",
      showMsg: "",
      successMsg: "",
      showSuccessMsg: "",
      fullname: null,
      email: null,
      cpf: null,
      cnpj: null,
      phone: null,
      celphone: null,
      address: null,
      hood: null,
      city: null,
      province: null,
      cep: null,
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
      picture: null,
      isUploadingPicture: false,
      storeCategories: null,
      selectedCategories: [],
      selectedStoreCategories: [],
      selectedHability: null,
      arrHabilitiesWithMessages: [
        {
          'message': 'Sou advogado(a), tenho conhecimento de contratos',
          'hability': 'advogado'
        },
        {
          'message': 'Sou empreendedor(a), posso contribuir com uma palestra sobre este tema e suas habilidades',
          'hability': 'empreendedor'
        },
        {
          'message': 'Sou criativo(a), quero contribuir com idéias e soluções, posso contribuir também com copy',
          'hability': 'criacao'
        },
        {
          'message': 'Sou programador(a), tenho disponibilidade para desenvolver e integrar APIs',
          'hability': 'programador'
        },
        {
          'message': 'Sou designer, posso ajudar na criação de templates e apresentações',
          'hability': 'designer'
        },
        {
          'message': 'Trabalho com tecnologia, conheçø várias ferramentas gratuitas de gestão e colaboração',
          'hability': 'ti'
        },
        {
          'message': 'Trabalho como redator(a), possuo boas habilidades de escrita e textuais',
          'hability': 'redator'
        },
        {
          'message': 'Sou palestrante, estou disponível para uma palestra presencial ou online',
          'hability': 'palestrante'
        },
        {
          'message': 'Trabalho com marketing digital, quero contribuir com esta habilidade',
          'hability': 'marketing'
        },
        {
          'message': 'Sou influenciador(a), quero divulgar uma ONG e ajudá-la na captação de recursos',
          'hability': 'influencer'
        },
      ],
      showHabilityModal: false
    }
  },
  created(){
    this.loadUserData();
    this.storeCategories = constants.STORE_CATEGORIES;
    this.storeCategories.sort(function(a, b){
      if(a.categoryName < b.categoryName) { return -1; }
      if(a.categoryName > b.categoryName) { return 1; }
      return 0;
    })
  },
  methods: {
    loadUserData(){
      if(this.user.Info){
        this.fullname = this.user.Info.fullname;
        if(this.isFacebookUser){
          this.email = (this.user.Info.email) ? this.user.Info.email : '';
        }else{
          this.email = (this.user.Info.email != '') ? this.user.Info.email : this.username;
        }
        this.cpf = this.user.Info.cpf;
        this.cnpj = this.user.Info.cnpj;
        this.phone = this.user.Info.phone;
        this.celphone = this.user.Info.celphone;
        this.address = this.user.Info.address;
        this.hood = this.user.Info.hood;
        this.city = this.user.Info.city;
        this.province = this.user.Info.province;
        this.cep = this.user.Info.cep;
      }
      this.selectedCategories = this.user.favoritedCategories;
      this.selectedStoreCategories = this.user.favoritedStoreCategories;
      this.picture = (this.user && this.user.picture) ? this.user.picture : 'https://via.placeholder.com/55x55';
      if(!this.user.hability){
        this.showHabilityModal = true;
      }else{
        this.selectedHability = this.user.hability;
      }
    },
    save(){
      this.$emit('showloading');
      if(this.validate()){
        this.$http.post(API.Profile.profileUpdate, {
          fullname: this.fullname,
          email: this.email,
          cpf: this.cpf,
          cnpj: this.cnpj,
          phone: this.phone,
          celphone: this.celphone,
          address: this.address,
          hood: this.hood,
          city: this.city,
          province: this.province,
          cep: this.cep,
          password: this.password,
          favoritedCategories: this.selectedCategories,
          favoritedStoreCategories: this.selectedStoreCategories,
          hability: this.selectedHability,
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirm,
          picture: this.picture,
          formType: 'updateProfile'
        }, {headers: auth.getHeaders()}).then((response) => {
          if(response.body.success == true){
            this.successMsg = response.body.message;
            this.showSuccessMsg = true;
          }else{
            this.msg = response.body.message;
            this.showMsg = true;
          }
          this.password = null;
          this.newPassword = null;
          this.newPasswordConfirm = null;
          this.$emit('hideloading');
        }, (error) => {
          console.log(error)
        });
      }else{
        this.$emit('hideloading');
      }
    },
    selectPhoto(){
      this.$refs.uploadBtn.click();
    },
    uploadPhoto(e){
      e.preventDefault();
      this.isUploadingPicture = true;
      var file = e.target.files[0]
      var reader = new FileReader();
      var $this = this;
      reader.addEventListener('loadend', (e) => {
        $this.$http.post(API.Profile.profileUpdate, {uploadPhoto: true, fileName: file.name, fileType: file.type, formType: 'uploadPhoto'}, {headers: auth.getHeaders()})
        .then((res) => {
          return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
        })
        .then((res) => {
          var picture = res.url.split('?');
          $this.isUploadingPicture = false;
          $this.picture = picture[0];
        })
      })
      reader.readAsArrayBuffer(file);
    },
    validate(){
      if(this.fullname == '' || this.fullname == null){
        this.showMessage("Insira o seu nome completo.");
        return false;
      }
      if(this.email == '' || this.email == null){
        this.showMessage("Insira um e-mail válido.");
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.showMessage("E-mail inválido. Insira um e-mail no formato correto.");
        return false;
      }
      if(this.newPassword && this.newPassword != '' && !this.password){
        this.showMessage("Você deve informar a sua senha atual antes de alterá-la.");
        return false;
      }
      if(this.newPassword && this.newPassword != '' && this.newPassword != this.newPasswordConfirm){
        this.showMessage("Senhas novas não conferem.");
        return false;
      }
      return true;
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    }
  },
  watch: {
    user: function(newVal, oldVal) {
      this.loadUserData();
    }
  }
}
</script>

<style lang="scss" scoped>
.input-photo{
  display: none;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }

    .profile-photo{
      width: 60px;
      height: 60px;
    }

    .change-photo{
      text-decoration: none;
      color: #333;
      margin-left: 20px;
    }

    .profile-data{
      .row{
        padding: 0px;
        border-bottom: none;
      }
    }

    .submit{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/FormProfile.vue